const GUEST_NAME_KEY = 'guestName';

export function getStoredGuestName(): string | null {
  if (typeof window === 'undefined') return null;

  const guestName = window.localStorage.getItem(GUEST_NAME_KEY);
  if (!guestName || guestName === 'null' || guestName.trim() === '') return null;

  return guestName;
}

export function ensureGuestName(): string {
  if (typeof window === 'undefined') return 'Convidado';

  const existingName = getStoredGuestName();
  if (existingName) return existingName;

  const guestName = `Convidado${Math.floor(Math.random() * 1000)}`;
  window.localStorage.setItem(GUEST_NAME_KEY, guestName);
  return guestName;
}
